const nextFrame = (callback) => window.requestAnimationFrame(callback)
const cancelFrame = (handle) => window.cancelAnimationFrame(handle)
const isPageHidden = () => document.visibilityState === "hidden"

// Regroupe les mises à jour de machines reçues pendant une même image : React 18 ne regroupe que les mises à jour
// d'un même événement, et une rafale de 5 update-machine arrive en autant d'événements socket distincts.
// Chaque mise à jour garde l'instant de sa réception : le store s'en sert pour ne pas écraser un rechargement plus récent.
export function createUpdateBuffer(apply, {
    schedule = nextFrame,
    cancelSchedule = cancelFrame,
    isHidden = isPageHidden,
    now = Date.now,
} = {}) {
    let pending = new Map()
    let handle = null

    const flushPending = () => {
        const entries = Array.from(pending.values())
        pending = new Map()
        entries.forEach(({update, receivedAt}) => apply(update, receivedAt))
    }

    const onFrame = () => {
        handle = null
        flushPending()
    }

    const push = (update) => {
        if (!update || update.id === undefined) {
            return
        }

        const receivedAt = now()
        const previous = pending.get(update.id)
        // Une mise à jour partielle (sans tâches) complète celle en attente et garde son instant de réception ;
        // une mise à jour complète la remplace.
        pending.set(update.id, previous && update.tasks === undefined
            ? {update: {...previous.update, ...update}, receivedAt: previous.receivedAt}
            : {update, receivedAt})

        // Page cachée (onglet en arrière-plan, tablette en veille) : aucune image ne viendra avant le retour sur l'écran.
        if (isHidden()) {
            if (handle !== null) {
                cancelSchedule(handle)
                handle = null
            }
            flushPending()
            return
        }

        if (handle === null) {
            handle = schedule(onFrame)
        }
    }

    const cancel = () => {
        if (handle !== null) {
            cancelSchedule(handle)
        }
        handle = null
        pending = new Map()
    }

    return {push, cancel}
}
